// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1-4sP","paramInput":"JobSimulator_paramInput__22YjF","input":"JobSimulator_input__3cJD7"};